import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["appearance", "className", "children", "density", "intent", "isDisabled", "label", "onDismiss", "shape", "size"];
import * as React from 'react';
import cn from 'classnames';
import { IconClose } from '../../../icons';
import { intentClass, ControlSizeType, ControlAppearanceType, Intent, safeInvoke, ControlDensityType, isFunction, isDefined, marginClass, mergeSpacingProps, paddingClass } from '../../../library';
export var tagClasses = {
  MAIN: 'tag',
  DISMISS: 'tag__dismiss',
  GROUP: 'tags'
};
function getTagClasses(props) {
  var marginClasses = marginClass(mergeSpacingProps({
    spacing: props.margin,
    spacingBottom: props.marginBottom,
    spacingLeft: props.marginLeft,
    spacingRight: props.marginRight,
    spacingTop: props.marginTop,
    spacingX: props.marginX,
    spacingY: props.marginY
  }));
  var paddingClasses = paddingClass(mergeSpacingProps({
    spacing: props.padding,
    spacingBottom: props.paddingBottom,
    spacingLeft: props.paddingLeft,
    spacingRight: props.paddingRight,
    spacingTop: props.paddingTop,
    spacingX: props.paddingX,
    spacingY: props.paddingY
  }));
  return cn(tagClasses.MAIN, _defineProperty(_defineProperty(_defineProperty({
    '-sm': props.size === ControlSizeType.SMALL,
    '-lg': props.size === ControlSizeType.LARGE,
    '-dismissable': isDefined(props.onDismiss),
    '-disabled': props.isDisabled
  }, "-".concat(props.density), props.density), "-".concat(props.appearance), props.appearance), "-".concat(props.shape), props.shape), intentClass(props.intent), marginClasses, paddingClasses, props.className);
}
export var TagLink = React.forwardRef(function (props, ref) {
  var _props$children;
  var appearance = props.appearance,
    className = props.className,
    children = props.children,
    density = props.density,
    intent = props.intent,
    isDisabled = props.isDisabled,
    label = props.label,
    onDismiss = props.onDismiss,
    shape = props.shape,
    size = props.size,
    htmlProps = _objectWithoutProperties(props, _excluded);
  var classNames = getTagClasses(props);
  var handleDismiss = function handleDismiss(e) {
    e.preventDefault();
    if (isDisabled) return;
    safeInvoke(onDismiss, e);
  };
  var handleClick = function handleClick(e) {
    if (isDisabled) {
      e.preventDefault();
    }
    safeInvoke(props.onClick, e);
  };
  var closeSize = 12;
  switch (props.size) {
    case ControlSizeType.SMALL:
      closeSize = 10;
      break;
    case ControlSizeType.LARGE:
      closeSize = 16;
      break;
  }
  return React.createElement("a", _extends({
    ref: ref,
    className: classNames
  }, htmlProps, {
    onClick: handleClick
  }), (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : props.label, isFunction(props.onDismiss) ? React.createElement("div", {
    className: cn(tagClasses.DISMISS, {
      '-disabled': props.isDisabled
    }),
    onClick: handleDismiss
  }, React.createElement(IconClose, {
    size: closeSize
  })) : null);
});
TagLink.displayName = 'TagLink';
TagLink.defaultProps = {
  appearance: ControlAppearanceType.MINIMAL,
  density: ControlDensityType.NORMAL,
  intent: Intent.NONE,
  size: ControlSizeType.MEDIUM
};
export var Tag = React.forwardRef(function (props, ref) {
  var classNames = getTagClasses(props);
  var handleDismiss = function handleDismiss(e) {
    if (props.isDisabled) return;
    safeInvoke(props.onDismiss, e);
  };
  var closeSize = 12;
  switch (props.size) {
    case ControlSizeType.SMALL:
      closeSize = 10;
      break;
    case ControlSizeType.LARGE:
      closeSize = 16;
      break;
  }
  return React.createElement("div", {
    ref: ref,
    className: classNames
  }, isDefined(props.children) ? props.children : props.label, isFunction(props.onDismiss) ? React.createElement("div", {
    className: cn(tagClasses.DISMISS, {
      '-disabled': props.isDisabled
    }),
    onClick: handleDismiss
  }, React.createElement(IconClose, {
    size: closeSize
  })) : null);
});
Tag.displayName = 'Tag';
Tag.defaultProps = {
  appearance: ControlAppearanceType.MINIMAL,
  density: ControlDensityType.NORMAL,
  intent: Intent.NONE,
  size: ControlSizeType.MEDIUM
};